// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.staff-detail-modal {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
  animation: modalFadeIn 0.3s ease;
}

.modal-content {
  animation: modalSlideIn 0.3s ease;
  background: white;
  padding: 40px;
  border-radius: var(--radius-lg);
  width: 92%;
  max-width: 1100px;
  max-height: 92vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--background-light);
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.close-button:hover {
  background: var(--text-secondary);
  color: white;
  transform: rotate(90deg);
}

.personal-info {
  background: white;
  padding: 28px;
  border-radius: var(--radius-lg);
  margin: 28px 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.personal-info:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
}

.staff-detail-modal table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin: 16px 0;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.staff-detail-modal th,
.staff-detail-modal td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.staff-detail-modal td:hover {
  white-space: normal;
  overflow: visible;
}

.vehicle-categories table,
.endorsements table {
  font-size: 0.85em;
}

.staff-detail-modal th {
  background-color: var(--background-light);
  font-weight: 600;
  color: var(--text-primary);
}

.staff-detail-modal h2 {
  color: var(--text-primary);
  margin-bottom: 24px;
  font-size: 1.75rem;
}

.staff-detail-modal h3 {
  color: var(--text-secondary);
  margin: 32px 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--border-color);
  font-size: 1.25rem;
}

.endorsements,
.vehicle-categories,
.license-checks {
  background: white;
  padding: 28px;
  border-radius: var(--radius-lg);
  margin: 28px 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.endorsements:hover,
.vehicle-categories:hover,
.license-checks:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
}

/* Animations */
@keyframes modalFadeIn {
  from {
    opacity: 0;
    backdrop-filter: blur(0);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(4px);
  }
}

@keyframes modalSlideIn {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Enhanced mobile responsiveness */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    padding: 20px;
    margin: 10px;
    max-height: 95vh;
  }

  .close-button {
    top: 10px;
    right: 10px;
    width: 32px;
    height: 32px;
  }

  .personal-info,
  .endorsements,
  .vehicle-categories,
  .license-checks {
    padding: 16px;
    margin: 16px 0;
  }

  .staff-detail-modal table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  .staff-detail-modal th,
  .staff-detail-modal td {
    padding: 8px;
    font-size: 0.85rem;
  }

  .staff-detail-modal h2 {
    font-size: 1.25rem;
  }

  .staff-detail-modal h3 {
    font-size: 1.1rem;
    margin: 20px 0 12px 0;
  }
}

@media (max-width: 480px) {
  .modal-content {
    padding: 16px;
  }

  .personal-info,
  .endorsements,
  .vehicle-categories,
  .license-checks {
    padding: 12px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/StaffDetail.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,aAAa;EACb,+BAA+B;EAC/B,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;EACjB,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;;;EAGE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,UAAU;IACV,aAAa;IACb,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;EACd;;EAEA;;;;IAIE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;;;IAIE,aAAa;EACf;AACF","sourcesContent":[".staff-detail-modal {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n  animation: modalFadeIn 0.3s ease;\n}\n\n.modal-content {\n  animation: modalSlideIn 0.3s ease;\n  background: white;\n  padding: 40px;\n  border-radius: var(--radius-lg);\n  width: 92%;\n  max-width: 1100px;\n  max-height: 92vh;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.close-button {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--background-light);\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.close-button:hover {\n  background: var(--text-secondary);\n  color: white;\n  transform: rotate(90deg);\n}\n\n.personal-info {\n  background: white;\n  padding: 28px;\n  border-radius: var(--radius-lg);\n  margin: 28px 0;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.personal-info:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);\n}\n\n.staff-detail-modal table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  margin: 16px 0;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n}\n\n.staff-detail-modal th,\n.staff-detail-modal td {\n  padding: 8px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.staff-detail-modal td:hover {\n  white-space: normal;\n  overflow: visible;\n}\n\n.vehicle-categories table,\n.endorsements table {\n  font-size: 0.85em;\n}\n\n.staff-detail-modal th {\n  background-color: var(--background-light);\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.staff-detail-modal h2 {\n  color: var(--text-primary);\n  margin-bottom: 24px;\n  font-size: 1.75rem;\n}\n\n.staff-detail-modal h3 {\n  color: var(--text-secondary);\n  margin: 32px 0 16px 0;\n  padding-bottom: 8px;\n  border-bottom: 2px solid var(--border-color);\n  font-size: 1.25rem;\n}\n\n.endorsements,\n.vehicle-categories,\n.license-checks {\n  background: white;\n  padding: 28px;\n  border-radius: var(--radius-lg);\n  margin: 28px 0;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.endorsements:hover,\n.vehicle-categories:hover,\n.license-checks:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);\n}\n\n/* Animations */\n@keyframes modalFadeIn {\n  from {\n    opacity: 0;\n    backdrop-filter: blur(0);\n  }\n  to {\n    opacity: 1;\n    backdrop-filter: blur(4px);\n  }\n}\n\n@keyframes modalSlideIn {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Enhanced mobile responsiveness */\n@media (max-width: 768px) {\n  .modal-content {\n    width: 95%;\n    padding: 20px;\n    margin: 10px;\n    max-height: 95vh;\n  }\n\n  .close-button {\n    top: 10px;\n    right: 10px;\n    width: 32px;\n    height: 32px;\n  }\n\n  .personal-info,\n  .endorsements,\n  .vehicle-categories,\n  .license-checks {\n    padding: 16px;\n    margin: 16px 0;\n  }\n\n  .staff-detail-modal table {\n    display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n\n  .staff-detail-modal th,\n  .staff-detail-modal td {\n    padding: 8px;\n    font-size: 0.85rem;\n  }\n\n  .staff-detail-modal h2 {\n    font-size: 1.25rem;\n  }\n\n  .staff-detail-modal h3 {\n    font-size: 1.1rem;\n    margin: 20px 0 12px 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .modal-content {\n    padding: 16px;\n  }\n\n  .personal-info,\n  .endorsements,\n  .vehicle-categories,\n  .license-checks {\n    padding: 12px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
